import HannahHeckmann from "./pages/HannahHeckmann";
import "./App.css";

function App() {
  return (
    <div className="App">
      <HannahHeckmann />
    </div>
  );
}

export default App;